module.exports = __webpack_public_path__ + "img/img1.f9fc616b.png";